import { render, staticRenderFns } from "./Preview-File.vue?vue&type=template&id=640b215c&scoped=true"
import script from "./Preview-File.vue?vue&type=script&lang=js"
export * from "./Preview-File.vue?vue&type=script&lang=js"
import style0 from "./Preview-File.vue?vue&type=style&index=0&id=640b215c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640b215c",
  null
  
)

export default component.exports